import qs from 'qs';
import { z } from 'zod';

import { RouterLink } from '../../generic/Link';

import styles from './ForgotPasswordLink.module.less';

export type ForgotPasswordLinkProps = {
  /**
   * The identifier already entered in the login flow. Carried to the reset page as an `?email=` prefill when it
   * is an email address; a bare username is dropped — the reset request only matches on email, so prefilling a
   * username would just be a value the person has to delete.
   */
  identifier?: string;
  next?: string;
};

const emailSchema = z.email();

/**
 * "Forgot password?" link to the password-reset page, carrying the entered email and any `?next=` deep-link so
 * the reset form starts prefilled and the post-reset login keeps the original destination.
 */
const ForgotPasswordLink = ({ identifier, next }: ForgotPasswordLinkProps) => {
  const email = identifier && emailSchema.safeParse(identifier).success ? identifier : undefined;
  const query = qs.stringify({ email, next }, { skipNulls: true });
  return (
    <div className={styles.forgotPassword}>
      <RouterLink to={query ? `/auth/password-reset?${query}` : '/auth/password-reset'}>Forgot password?</RouterLink>
    </div>
  );
};

export default ForgotPasswordLink;
